export interface ICalendarTaskPermissions {
    canSaveCalendarTask: boolean;
    canRemoveCalendarTask: boolean;
}

export class CalendarTaskPermissions implements ICalendarTaskPermissions {
    canSaveCalendarTask: boolean;
    canRemoveCalendarTask: boolean;

    constructor();
    constructor(obj: ICalendarTaskPermissions);
    constructor(obj?: any) {
        this.canSaveCalendarTask = obj && obj.canSaveCalendarTask || false;
        this.canRemoveCalendarTask = obj && obj.canRemoveCalendarTask || false;
    }
}